import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuMonitors = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 18",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 9.5h3.2L5.76.61l4.48 16.76L12.8 9.5H16",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgMainMenuMonitors);
export default ForwardRef;
